const changePasswordStr = {
  toastr: 'contraseña cambiada',
  toastr1: 'contraseña cambiada con éxito',
  toastrError: 'Contraseña incorrecta',
  toastrError1: 'La contraseña antigua no coincide'
};

export default changePasswordStr;
